import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2508edf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-result-wrapper" }
const _hoisted_2 = { class: "result-items" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_select_search = _resolveDirective("select-search")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewForecasts, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.companyId
        }, [
          _createElementVNode("a", {
            href: _ctx.url + item.ticker,
            target: "_blank",
            class: _normalizeClass(["result ticker", { active: index === _ctx.selectedPreviewItem }])
          }, [
            _withDirectives((_openBlock(), _createElementBlock("b", null, [
              _createTextVNode(_toDisplayString(item.ticker), 1)
            ])), [
              [_directive_select_search, _ctx.search]
            ])
          ], 10, _hoisted_3),
          _createElementVNode("a", {
            href: _ctx.url + item.ticker,
            target: "_blank",
            class: _normalizeClass(["result name", { active: index === _ctx.selectedPreviewItem }])
          }, [
            _withDirectives((_openBlock(), _createElementBlock("span", null, [
              _createTextVNode(_toDisplayString(item.name), 1)
            ])), [
              [_directive_select_search, _ctx.search]
            ])
          ], 10, _hoisted_4)
        ], 64))
      }), 128))
    ])
  ], 512)), [
    [_vShow, _ctx.previewForecasts.length && _ctx.search]
  ])
}